<template>
  <div class="th-list-course">
    <h2 class="th-title"><b>Data Center Dashboard</b></h2>

    <a-card>
      <div class="mb-3 row">
        <div class="col-sm-4 col-md-3 m-1">
          <a-input-search
            v-model:value="search"
            placeholder="Cari Nama Manufaktur atau Tag..."
            allow-clear
          />
        </div>
        <div class="col m-1 w-100 d-flex justify-content-end align-items-center">
          <a-button @click="$router.push({ name: 'Buat Base Manufaktur' })">
            <PlusOutlined />Manufaktur Baru
          </a-button>
        </div>
      </div>

      <div class="w-100" style="overflow-x: auto">
        <a-table
          :loading="loadingTable"
          :columns="columns"
          :data-source="filteredData"
          :pagination="globalPagination"
          @change="handleTableChange"
          class="table"
          bordered
          table-layout="auto"
        >
          <template #name="{ text, record }">
            <router-link
              class="th-link"
              :to="{
                name: 'Detail Base Manufaktur',
                params: { id: record.id },
              }"
            >
              {{ text }}
            </router-link>
          </template>
          <template #action="{ record }">
            <a-button type="danger" @click="openDeleteModal(record.id)">
              <RestOutlined :style="{ color: 'white' }" />
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>

    <a-modal
      v-model:visible="isDeleteModalVisible"
      title="Konfirmasi Penghapusan"
      ok-text="Hapus"
      ok-type="danger"
      cancel-text="Batal"
      centered
      @ok="handleDelete"
      @cancel="closeDeleteModal"
    >
      <p>
        Apakah Anda yakin ingin menghapus manufaktur ini? Data manufaktur yang terpakai pada aset
        tidak akan bisa dihapus.
      </p>
    </a-modal>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'
import { getManufactures, deleteManufacturers } from '../../../services/axios/modc/manufacture'
import { PlusOutlined, RestOutlined } from '@ant-design/icons-vue'
import moment from 'moment'

export default {
  components: {
    PlusOutlined,
    RestOutlined,
  },
  setup() {
    const router = useRouter()

    // --- State Management ---
    const loadingTable = ref(false)
    const search = ref('')
    const masterData = ref([])
    const globalPagination = ref({ current: 1, pageSize: 10 })
    const isDeleteModalVisible = ref(false)
    const manufacturerIdToDelete = ref(null)

    const columns = [
      {
        title: 'MANUFAKTUR',
        dataIndex: 'name',
        key: 'name',
        slots: { customRender: 'name' },
        width: 150,
      },
      {
        title: 'TAGS',
        dataIndex: 'tag',
        key: 'tag',
      },
      {
        title: 'Action',
        key: 'action',
        slots: { customRender: 'action' },
        align: 'center',
        width: 100,
      },
    ]

    const filteredData = computed(() => {
      const searchTerm = search.value.toLowerCase()
      if (!searchTerm) {
        return masterData.value
      }
      return masterData.value.filter(
        item =>
          (item.name && item.name.toLowerCase().includes(searchTerm)) ||
          (item.tag && item.tag.toLowerCase().includes(searchTerm)),
      )
    })

    const fetchAllManufactures = async () => {
      loadingTable.value = true
      try {
        const data = await getManufactures()
        masterData.value = data.manufacturers
        globalPagination.value.total = data.manufacturers.length
      } catch (error) {
        console.error('Gagal mengambil data manufaktur:', error)
        notification.error({
          message: 'Gagal Memuat Data',
          description: 'Terjadi kesalahan saat mengambil daftar manufaktur.',
        })
      } finally {
        loadingTable.value = false
      }
    }

    onMounted(fetchAllManufactures)

    const deleteManufacturerFunc = async manufacturerId => {
      try {
        await deleteManufacturers(manufacturerId)
        notification.success({
          message: 'Berhasil',
          description: 'Manufaktur telah berhasil dihapus.',
        })
        await fetchAllManufactures() // Muat ulang data setelah sukses
      } catch (error) {
        console.error('Gagal menghapus manufaktur:', error)
        const errorMsg =
          error.response?.data?.message || 'Terjadi kesalahan saat mencoba menghapus manufaktur.'
        notification.error({
          message: 'Gagal Menghapus',
          description: errorMsg,
        })
      }
    }

    const openDeleteModal = manufacturerId => {
      manufacturerIdToDelete.value = manufacturerId
      isDeleteModalVisible.value = true
    }

    const closeDeleteModal = () => {
      isDeleteModalVisible.value = false
      manufacturerIdToDelete.value = null
    }

    const handleDelete = () => {
      if (manufacturerIdToDelete.value) {
        deleteManufacturerFunc(manufacturerIdToDelete.value)
      }
      closeDeleteModal()
    }

    const handleTableChange = pagination => {
      globalPagination.value.current = pagination.current
    }

    return {
      search,
      columns,
      loadingTable,
      globalPagination,
      filteredData,
      handleTableChange,
      isDeleteModalVisible,
      openDeleteModal,
      handleDelete,
    }
  },

  computed: {
    getDate() {
      return moment().format('DD/MMM/YYYY | HH:mm:ss')
    },
  },
}
</script>

<style lang="scss">
@import '@/views/styleViews.scss';

.text-manufacture {
  font-size: 0.75rem;
}

.th-list-course {
  .th-link {
    color: var(--vb-color-primary) !important;

    &:hover {
      color: var(--kit-color-primary) !important;
    }
  }
}
</style>
